import { render, staticRenderFns } from "./ChangePasswordPopup.vue?vue&type=template&id=1277d9ff"
import script from "./ChangePasswordPopup.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports